import React from "react"
import { useAnsweredFormOverviewContext } from "contexts/AnsweredFormOverviewContext"
import { questionShape } from "utils/propTypeShapes"
import { QuestionBranchingConditionalCheck, QuestionContainer } from "shared/form"
import AnsweredFormOverviewQuestionAnswer from "./AnsweredFormOverviewQuestionAnswer"

const AnsweredFormOverviewQuestion = ({ question }) => {
  const { conditionals = null, prompt, uuid: questionUuid } = question

  const { answers, isNewQuestion, isQuestionFlagged } = useAnsweredFormOverviewContext()

  return (
    <QuestionBranchingConditionalCheck conditionals={conditionals} formAnswers={answers}>
      <QuestionContainer flagged={isQuestionFlagged(questionUuid)} isNewQuestion={isNewQuestion(questionUuid)} prompt={prompt}>
        <AnsweredFormOverviewQuestionAnswer answers={answers} isNewQuestion={isNewQuestion(questionUuid)} question={question} />
      </QuestionContainer>
    </QuestionBranchingConditionalCheck>
  )
}

AnsweredFormOverviewQuestion.propTypes = {
  question: questionShape.isRequired,
}

export default AnsweredFormOverviewQuestion
